import { DexEntityTypeEnum, DexEntityTypeEnumType, DexRegionEnumType } from '@mark43/cad-api';

export function useShouldShowRequestorSelect(
    dexEntityType: DexEntityTypeEnumType,
    dexRegion?: DexRegionEnumType,
    inquiryTypeCode?: string
): boolean {
    if (dexRegion === 'LA_LLETS') {
        return ([
            DexEntityTypeEnum.PERSON.name,
            DexEntityTypeEnum.VEHICLE.name,
        ] as DexEntityTypeEnumType[]).includes(dexEntityType);
    }

    //AZ_ACJIS: Show requestor only for Person DL (Driver License) queries
    if (dexRegion === 'AZ_ACJIS' && dexEntityType === DexEntityTypeEnum.PERSON.name) {
        return inquiryTypeCode === 'DL';
    }

    return false;
}
